import {Collapse} from '@mui/material';

export default Collapse;
